import React from 'react';
import AboutHero from '../components/AboutHero';
import Journey from '../components/Journey';
import Humanity from '../components/Humanity';
import Education from '../components/Education';
import Passion from '../components/Passion';
import HerMusic from '../components/HerMusic';
import Closing from '../components/Closing';
import Seo from '../components/Seo';
import { SEO_META } from '../mock';

const AboutPage = ({ onPlay }) => {
  return (
    <main>
      <Seo {...SEO_META.about} />
      <AboutHero />
      <Journey />
      <Humanity />
      <Education />
      <Passion />
      <HerMusic onPlay={onPlay} />
      <Closing />
    </main>
  );
};

export default AboutPage;
